import React from 'react';
import PropTypes from 'prop-types';
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { useLocomotiveScroll } from 'react-locomotive-scroll';

import useLanguage from '../../../hooks/useLanguage';
import PlayTextUa from '../../../svg/play_text_ua.svg';
import PlayTextRu from '../../../svg/play_text_ru.svg';
import PlayIcon from '../../../svg/play_poligon.svg';
import VideoModal from './VideoModal/VideoModal';

const Video = ({ videoData }) => {

  const image = getImage(videoData.cover.localFile);

  const { scroll } = useLocomotiveScroll();

  const [open, setOpen] = React.useState(false);
  const [play, setPlay] = React.useState(false);

  function playReel(e) {
    e.preventDefault();
    setOpen(true);
    scroll.stop();
    setTimeout(() => {
      setPlay((play) => true);
    }, 3000);
  }

  function stopReel() {
    setOpen(false);
    setPlay(false);
    scroll.start();
  }

  const PlayText = useLanguage(
    <PlayTextUa className="video-icon__text" />,
    <PlayTextRu className="video-icon__text" />
  );

  const videoLink = useLanguage(videoData.video_ua, videoData.video_ru);

  return (
    <>
      <section className="video" data-scroll-section>
        <div className="video-cover" onClick={playReel} role="presentation">
          <div
            className="video-cover__wrapper-overflow"
            data-scroll=""
            data-scroll-speed="-1.5"
          >
            <div className="video-cover__wrapper">
              <GatsbyImage
                image={image}
                className="video-cover__image"
                alt="video"
              />
            </div>
          </div>
          <div className="video-icon">
            {PlayText}
            <PlayIcon className="video-icon__play" />
          </div>
        </div>
      </section>
      <VideoModal
        stopReel={stopReel}
        play={play}
        open={open}
        video={videoLink}
      />
    </>
  );
};

Video.propTypes = {
  videoData: PropTypes.object,
};

export default Video;
